module.exports = __webpack_public_path__ + "img/logo-shiba888.4bbf5df0.png";